<p-table [value]="ladderTreeNodes" dataKey="label">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Bucket</th>
            <th *ngFor="let ladderColumnName of ladderColumnNames">
                {{ladderColumnName}}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
        <tr>
            <td>
                <a href="#" [pRowToggler]="rowData">
                    <i
                        [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </a>
                {{rowData.label}}
            </td>
            <ng-template ngFor let-item [ngForOf]="ladderColumnNames" let-i="index">
                <td *ngIf="showDelta" class="right">{{rowData.data.deltas[i] | number:'1.2-2'}}</td>
                <td *ngIf="!showDelta" class="right">{{rowData.data.amounts[i] | number:'1.2-2'}}</td>
            </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
        <tr>
            <td [attr.colspan]="ladderColumnNames.length + 1">
                <h1>Some content goes here!!</h1>
                <h1>Some content goes here!!</h1>
                <h1>Some content goes here!!</h1>
            </td>
        </tr>
    </ng-template>
</p-table>